import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/report-payroll-details',
    name: 'report-payroll-detail',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/report-payroll-detail/index.vue')
  }
]
